import React from 'react';
import { Alert, Platform } from 'react-native';
import Constants from 'expo-constants';
import Storage from './Storage';
import { api, url } from '../constants/DevProd';
import Toast from 'react-native-root-toast';
import Colors from '../constants/Colors';

// rtApi.request('login', 'POST', fd)
// .then(data => {
// if (data.notLoggedIn) { setUser({ isLoggedIn: false }); rtApi.cancel(); return; }
// }).catch(err => {
// }).finally(() => {
// });
const ac = new AbortController();
const get = (url) => {
  return request(url, 'GET');
}
const remove = (url) => {
  return request(url, 'DELETE');
}
const post = (url, data) => {
  return request(url, 'POST', data);
}
const put = (url, data) => {
  return request(url, 'PUT', data);
}
const request = async (url, method, data) => {
  const rtJWT = await Storage.getItem('rtJWT');
  console.log('api request initial', url, method, data, api.base, rtJWT);
  return new Promise((resolve, reject) => {
    let m = method || 'GET';
    let options = {
      method: m,
      // mode: 'no-cors',
      // credentials: 'include',
      // headers: {
      //   'Content-Type': 'application/json',
      // }
    };
    if(data !== undefined){
      options.body = data;
    }
    
    if(!url.includes('login') && rtJWT){
      options.headers = {
        'Authorization': `Bearer ${rtJWT}`,
        // 'Access-Control-Allow-Origin' : '*',
      }
    }
    fetch(api.base + url, options, { signal: ac.signal })
    .then(res => {
      // console.log('api request res: ', res);
      // console.log('api request res: ');
      // console.log('api request res.text(): ', res.text());
      if (res.ok || res.type === 'opaque'){
        return res.json();
      }
      throw res;
    })
    .then(data => {
      // console.log('api request data', data);
      saveToken(data);
      saveRequestTime();
      if (data.result) {
        // resolve({ notLoggedIn: true });
        resolve(data);
      } else {
        if(data.errors){
          let errors = data.errors.join('; ');
          console.log('data.errors.join()', errors);
          if (data.errors[0] === 'Not logged in') {
            console.log('not logged in');
            cancel();
            resolve({ notLoggedIn: true });
          }
          throw(data);
        }
        resolve(data);
      }
    })
    .catch((errData) => {
      console.log('api request catch', errData);
      // timeout here because in some places there is a modal loader overlay which isnt hidden until the .finally
      // in the parent function which calls the api and the alert wont be shown while the loader is visible
      setTimeout(()=> {
        let e = 'An unknown error occured';
        if(errData.errors && Array.isArray(errData.errors)){
          e = errData.errors.join('; ');
        }
        let toast = Toast.show(e, {
          duration: Toast.durations.LONG,
          position: Toast.positions.CENTER,
        });
        // if(Platform.OS !== 'web'){
        //   Alert.alert('Error', e);
        // }else{
        //   alert(e);
        // }
      }, 100);
      reject(errData);
    });
  });
}
const cancel = () => {
  ac.abort();
}

const saveToken = (data) => {
  if(data.token){
    Storage.setItem('rtJWT', data.token);
  }
}

const saveRequestTime = () => {
  console.log(`apiRequestTime is ${Date.now()}`);
  Storage.setItem('apiRequestTime', Date.now().toString());
}

export {
  get,
  post,
  remove,
  put,
  cancel,
}